<template>
  <div>
    <div class="d-flex">
      <div class="flex-grow-1 me-2">
        <div class="row">
          <div class="col" v-for="(title, i) in titleList" :key="i">
            <span class="text-danger" v-if="title.required">* </span>
            <label class="form-label">{{ title.name }}</label>
          </div>
        </div>
      </div>
      <!-- 占位 -->
      <div class="opacity-0">
        <b-button
          variant="primary"
          class="pb-0"
          size="sm"
          style="min-width: 4.5rem"
          >{{this.$t('page.solid')}}</b-button
        >
      </div>
    </div>
    <template v-if="showMeasureValues.length">
      <div
        class="d-flex"
        v-for="(measureValue, i) in showMeasureValues"
        :key="measureValue.id"
      >
        <div class="flex-grow-1 me-2">
          <div class="row">
            <div class="col">
              <input
                type="text"
                :class="[
                  'form-control',
                  submitted &&
                    (!measureValue.name || measureValue.name.length > 50) &&
                    'is-invalid',
                  !(
                    submitted &&
                    (!measureValue.name || measureValue.name.length > 50)
                  ) && 'mb-3',
                ]"
                :placeholder="this.$t('page.product-library.PleaseEnterThePointName')"
                v-model="measureValue.name"
                :disabled="measureValue.owner != 'self'"
              />
              <div
                v-show="
                  submitted &&
                  (!measureValue.name || measureValue.name.length > 50)
                "
                class="invalid-feedback"
              >
                <span>{{
                  !measureValue.name
                    ? validationTips.nameNotNull
                    : validationTips.charLengthLE50
                }}</span>
              </div>
            </div>
            <div class="col">
              <input
                type="text"
                :class="[
                  'form-control',
                  submitted &&
                    measureValue.unit &&
                    measureValue.unit.length > 50 &&
                    'is-invalid',
                ]"
                :disabled="measureValue.owner != 'self'"
                :placeholder="this.$t('page.product-library.PleaseEnterThePointUnit')"
                v-model="measureValue.unit"
              />
              <div
                v-show="
                  submitted &&
                  measureValue.unit &&
                  measureValue.unit.length > 50
                "
                class="invalid-feedback"
              >
                <span>{{ validationTips.charLengthLE50 }}</span>
              </div>
            </div>
            <div class="col">
              <Multiselect
                :class="[submitted && !measureValue.dtype && 'is-invalid']"
                v-model="measureValue.dtype"
                :close-on-select="true"
                :searchable="false"
                :canClear="false"
                :options="dataTypes"
                :disabled="measureValue.owner != 'self'"
              />
              <div
                v-show="submitted && !measureValue.dtype"
                class="invalid-feedback"
              >
                <span>{{ validationTips.dataTypeNotNull }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="position-relative">
          <b-button
            variant="primary"
            size="sm"
            :style="{
              minWidth: '4.5rem',
              marginTop: ' 0.34rem',
              opacity: measureValue.owner != 'self' ? 0 : 1,
            }"
            :disabled="measureValue.owner != 'self'"
            @click="tagMessageBox = i"
            >{{this.$t('base.delete')}}</b-button
          >
          <MessageBox
            v-if="tagMessageBox == i"
            :messageCont="`${this.$t('page.product-library.AreYouSureWantDelete')}?`"
            :messageIcon="'ri-error-warning-line'"
            :iconStyle="{ fontSize: '14px', color: '#f06548' }"
            :messageStyle="{ top: '-6rem', left: '-3.5rem' }"
            @makeSure="handleDelete(i)"
            @makeClose="tagMessageBox = null"
          ></MessageBox>
        </div>
      </div>
    </template>
    <div class="text-center mt-2">
      <b-button variant="primary" @click="handleAdd">{{this.$t('page.gauge_point.add')}}</b-button>
    </div>
  </div>
</template>

<script>
import Multiselect from "@vueform/multiselect";
import MessageBox from "@/components/common/MessageBox.vue";
import "@vueform/multiselect/themes/default.css";
import "@/default.scss";
import { v4 as uuidv4 } from "uuid";
export default {
  emits: ["update:measurements"],
  props: {
    submitted: Boolean,
    dataTypes: Array,
    validationTips: Object,
    measurements: {
      type: Array,
      default: () => {
        return [
          {
            name: "",
            unit: "",
            dtype: "string",
          },
        ];
      },
    },
  },
  data() {
    return {
      titleList: [
        {
          name: this.$t('page.work-order.device.name'),
          required: true,
        },
        {
          name: this.$t('page.work-order.device.unit'),
          required: false,
        },
        {
          name: this.$t('base.data_type'),
          required: true,
        },
      ],
      showMeasureValues: [],
      tagMessageBox: null,
    };
  },
  components: {
    MessageBox,
    Multiselect,
  },
  watch: {
    showMeasureValues: {
      handler(newVal) {
        this.$emit("update:measurements", newVal);
      },
      deep: true,
    },
    measurements: {
      handler(newVal) {
        this.showMeasureValues = newVal;
      },
      deep: true,
    },
  },
  methods: {
    handleAdd() {
      this.tagMessageBox = null;
      let defaultData = {
        id: uuidv4(),
        name: "",
        unit: "",
        dtype: "string",
        owner: "self",
        key: "measure" + new Date().getTime(),
      };
      this.showMeasureValues.push({ ...defaultData });
    },
    handleDelete(i) {
      this.showMeasureValues.splice(i, 1);
      this.tagMessageBox = null;
    },
    filterArr(item) {
      var type = false;
      this.showMeasureValues.map((s) => {
        if (item.name == s.name && item.id != s.id) {
          type = true;
        }
      });
      return type;
    },
  },
};
</script>
